<script>
    import { Row, Col, Card, CardBody } from 'sveltestrap'
    import { InputText, Select } from '@fno/component2/form.js'
    import { icons, urlPrefix } from 'fanx-schema/value/sportIcon'
    import sportsNames from 'fanx-schema/value/sportNames'

    export let context
    export let formKey
    export let index
    export let arenas

    $: {
        if (!context.form[formKey][index].attributes.sportIconImage) {
            context.form[formKey][index].attributes.sportIconImage = {}
        }
    }
    $: selectableSports = Object.keys(sportsNames).map((key) => ({ name: sportsNames[key], id: key }))
    $: selectableSportIcons = icons.map(({ name, filename }) => ({
        name,
        id: urlPrefix + filename
    }))
    $: selectableArenas = arenas.map((arena) => {
        return { id: arena.id, name: arena.attributes.name }
    })
</script>

<style>
    .sportIcon {
        height: 50px;
        margin-top: 15px;
    }
</style>

<Card>
    <CardBody>
        <Row>
            <Col xs="12" md="6" lg="6" xl="6">
                <InputText
                    label="Team Name"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.name"
                    bind:value={context.form[formKey][index].attributes.name}
                    on:change
                />
            </Col>
            <Col xs="12" md="6" lg="6" xl="6">
                <Select
                    options={selectableSports}
                    label="Sport"
                    required
                    {context}
                    {formKey}
                    {index}
                    includeDefaultValue
                    keypath="attributes.sport"
                    bind:value={context.form[formKey][index].attributes.sport}
                    on:change
                />
            </Col>
        </Row>

        <Row>
            <Col xs="12" md="6" lg="6" xl="6">
                <Select
                    label="Arena Name"
                    required
                    {context}
                    options={selectableArenas}
                    {formKey}
                    {index}
                    includeDefaultValue
                    keypath="attributes.arenaId"
                    bind:value={context.form[formKey][index].attributes.arenaId}
                    on:change
                />
            </Col>
            <Col xs="10" md="4" lg="4" xl="4">
                <Select
                    options={selectableSportIcons}
                    label="Sport Icon Image"
                    {context}
                    {formKey}
                    {index}
                    includeDefaultValue
                    keypath="attributes.sportIconImage.url"
                    bind:value={context.form[formKey][index].attributes.sportIconImage.url}
                    on:change
                />
            </Col>
            <Col xs="2" md="2" lg="2" xl="2">
                {#if context.form[formKey][index].attributes.sportIconImage.url}
                    <img
                        class="sportIcon"
                        src={context.form[formKey][index].attributes.sportIconImage.url}
                        alt="Selected sports icon"
                    />
                {/if}
            </Col>
        </Row>
    </CardBody>
</Card>
